import axios from "axios";
import axios1 from "@/assets/js/axios1.js";
import { voice_broadcast } from "@/assets/js/url.js";
// 加密
import Base64 from "@/assets/js/base64.js";
import md5 from "js-md5";
import CryptoJS from "@/assets/js/core.js";
var SHA256 = require("@/assets/js/sha256.js");
import getRandVal from "@/assets/js/index";
let hashValue = window.localStorage.getItem("hashValue");
let loginData = JSON.parse(window.localStorage.getItem("loginData"));

let token_init =
  "24.548aeb617071acfd2f747117a717c2b1.2592000.1555487733.282335-11344333";

function getPwdHash(pwd, data) {
  var sha = md5(pwd + data);
  var base = new Base64();
  var pwdHashStr = base.encode(sha);
  // console.log(pwdHashStr);
  return pwdHashStr;
}

export function get_voice_broadcast(content) {
  let commitData = {
    content: content,
  };
  const data = {
    type: "post",
    url: voice_broadcast,
    obj: commitData,
  };
  return axios1(data).then((res) => {
    if (res.data.success && res.data) {
      // token_init = res.data.data.voice_broadcast;
      console.log("返回语音播报内容", res.data);
      return res.data;
    }

    return "";
  });
}
// 判断一下本次存储是否存储token，如果有，判断一下时间，否则重新请求token
// if (window.localStorage.getItem('loginData') != null) {
//     get_bd_token();
// }

// export function bdAudio(loginName, text, token = token_init) {
//     return `http://tsn.baidu.com/text2audio?lan=zh&ctp=1&cuid=${loginName}&tok=${token}&tex=${encodeURI(text)}&vol=15&per=1&spd=5&pit=5`
// }



// WEBPACK FOOTER //
// ./src/assets/js/bdaudio.js